<template>
	<div class="result">
		<div class="image herobox-new">
			<div class="img-responsive">
				<a :href="resultUrl">
					<div style="position: relative;">
						<product-image v-if="result.cruises[0].route.images.length > 0" :image="result.cruises[0].route.images[result.cruises[0].route.images.length === 1 ? 0 : 1]" :width="500" :height="300" class="img-responsive image-result" />
						<div class="arrow-up" :class="{ routeoffer: offers.length }"></div>
					</div>
				</a>
				<div v-if="offers.length" :key="offers[0].id" class="route-offer">{{ offers[0].name }}</div>
			</div>
		</div>
		<div class="content">
			<h4><strong>{{ result.cruises[0].route.name }}</strong></h4>
			<div v-html="result.cruises[0].route.shortDescription"></div>
			<div class="row">
				<div class="col-xs-6">
					Region<br>
					<strong>{{ result.cruises[0].route.region.name }}</strong>
				</div>
				<div class="col-xs-6">
					Ships<br>
					<strong>{{ result.cruises.map(cruise => cruise.ship.name).join(', ') }}</strong>
				</div>
			</div>
			<div class="row">
				<div class="col-xs-12">
					Departure Dates<br>
					<strong>{{ departures.join(', ') }}</strong>
				</div>
			</div>
			<div class="price" v-if="Math.round(minimumPrice)">
				From £{{ formatNumber(Math.round(minimumPrice)) }} pp
			</div>
			<div>
				<a :href="resultUrl" class="btn btn-brand" style="max-width: fit-content;">VIEW MORE</a>
			</div>
		</div>
	</div>
</template>

<script>
import ProductImage from './ProductImage';

export default {
	props: [
		'result',
	],

	computed: {
		/**
		 * The price of the cheapest voyage, in pounds.
		 *
		 * @return {Number} The prices in pounds.
		 */
		minimumPrice: function () {
			let minPrice = this.result.cruises.reduce((minPrice, {minimumPrice}) => Math.min(minPrice, minimumPrice), Number.MAX_SAFE_INTEGER);

			return minPrice === Number.MAX_SAFE_INTEGER ? 0 : minPrice;
		},

		/**
		 * A list of departure dates.
		 *
		 * @return {Array} Returns an array of departure dates in UK date format.
		 */
		departures: function () {
			let departureDates = [];

			for (let i = 0; i < this.result.cruises.length; ++i) {
				const cruise = this.result.cruises[i];
				for (let j = 0; j < cruise.voyages.length; ++j)
					departureDates.push(cruise.voyages[j].from);
			}

			// Sort and de-duplicate.
			departureDates.sort();
			departureDates = departureDates.filter((date, index, arr) => index === arr.indexOf(date));

			// Convert to UK format.
			departureDates = departureDates.map(function (date) {
				date = date.split('-');
				const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
				return date[2] + '-' + months[date[1] - 1] + ' ' + date[0];
			});

			return departureDates;
		},

		/**
		 * A list of the offers that apply to voyages of the cruise.
		 *
		 * @return array Returns an array of offer information.
		 */
		offers: function () {
			// There may be multiple voyages with the same offer, so
			// create a Set that will store unique offers.
			var offers = new Set();

			for (let i = 0; i < this.result.cruises.length; ++i) {
				const cruise = this.result.cruises[i];
				for (let j = 0; j < cruise.voyages.length; ++j) {
					const voyage = cruise.voyages[j];

					for (let k = 0; k < voyage.offers.length; ++k)
						offers.add(voyage.offers[k]);
				}
			}

			// Convert the Set of unique offers to an array.
			return Array.from(offers);
		},

		resultUrl: function () {
			const filters = this.$store.getters.selectedFilterValues;
			const keys = Object.keys(filters);

			let url = [];

			for (let i = 0; i < keys.length; ++i)
			{
				const key = keys[i];
				const values = filters[key];

				for (let j = 0; j < values.length; ++j)
					url.push(key + '[]=' + values[j]);
			}

			return this.result.cruises[0].url + '?from=/cruise-search/?' + encodeURIComponent(url.join('&'));
		}
	},

	methods: {
		/**
		 * Add thousands separators to a number.
		 *
		 * @param {Number|String} The number to format.
		 *
		 * @return {String} Returns the number as a string with thousands separators.
		 */
		formatNumber: function (number) {
			const inputString = new String(number);
			let outputString = '';

			var decimalPosition = inputString.indexOf('.');
			if (decimalPosition != -1)
				outputString = inputString.substring(decimalPosition);
			else
				decimalPosition = inputString.length;

			for (let i = decimalPosition - 1, p = 0; i >= 0; --i, ++p) {
				if (p && !(p % 3))
					outputString = ',' + outputString;

				outputString = inputString[i] + outputString;
			}

			return outputString;
		},

		/**
		 * Calculates whether to show the region name on the result.
		 * Don't show it if the page is currently the same region as the result.
		 *
		 * @return {string} Either the region or blank if the page is already on the region.
		 */
		getRegionName()
		{
			if (window.location.pathname === this.result.cruises[0].route.region.url)
				return '';

			return this.result.cruises[0].route.region.name + ': ';
		},
	},

	components: {
		ProductImage,
	},
}
</script>

<style lang="scss" scoped>

h3 {
	font-size: 18px;
}

.images {
	text-align: center;
}

img {
	margin: auto;
	float: none;
}

.operator-image {
	max-height: 100px;
}

.price {
	font-size: 22px;
	margin: 20px 0;
}

#polar-routes .result a.btn {
	position: static;
}

.result {
	margin-bottom: 20px;
}

.content {
	padding-bottom: 20px;
	border-bottom: 1px solid black;
}

.herobox-new .arrow-up {
	border-left: 20px solid transparent;
	border-right: 20px solid transparent;
	border-bottom: 20px solid white;
	position: absolute;
	bottom: 0;
	left: 10px;
}

.herobox-new .arrow-up.routeoffer {
	border-bottom: 20px solid #bbcad5;
}

.route-offer {
	font-size: 16px;
	padding: 10px;
	color: #28354B;
	background: #bbcad5;
}

@media only screen and (max-width: 768px) {
	.image-result {
		object-fit: cover;
		height: 200px;
	}

	.operator-image {
		position: absolute;
		right: 0;
		bottom: 0;
		max-height: 50px;
		max-width: 50px;
	}
}
</style>
